'use strict';

var _ = require('lodash');
var PercentFilter = function PercentFilter() {
  return function (value, fractionalDigits) {
    value = parseFloat(value);
    if (isNaN(value)) {
      return value;
    }
    fractionalDigits = !_.isNil(fractionalDigits) ? fractionalDigits : 2;
    var truncatedValue = Number(Number(value * 100).toFixed(fractionalDigits));
    var roundedValue = Math.round(Number(truncatedValue));
    if (roundedValue === truncatedValue) {
      return roundedValue;
    } else {
      return truncatedValue;
    }
  };
};
PercentFilter.$inject = [];
module.exports = PercentFilter;